import { __assign } from "tslib";
import React from 'react';
import { Waypoint } from 'react-waypoint';
import Comment from '../../../Comment/presets/Comment';
import { updateCommentOffsetEveryPage } from '../../helpers';
var OffsetTrackingComment = function (props) {
    var onEnter = function () {
        return updateCommentOffsetEveryPage(props.comment, props.index);
    };
    return (React.createElement(Waypoint, { topOffset: "-100px", bottomOffset: "100%", onEnter: onEnter },
        React.createElement("div", null,
            React.createElement(Comment, __assign({}, props)))));
};
OffsetTrackingComment.displayName = 'OffsetTrackingComment';
export default OffsetTrackingComment;
//# sourceMappingURL=OffsetTrackingComment.js.map